"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Adapted from https://github.com/shoelace-style/react-wrapper/blob/master/src/react-wrapper.jsx
/* eslint-disable react/prop-types */
var _default = (tagName, incomingPropsModifierFunction) => {
  const CustomElement = tagName;

  // eslint-disable-next-line react/display-name
  return class extends _react.default.Component {
    constructor(props) {
      super(props);
      this.element = /*#__PURE__*/_react.default.createRef();
    }
    componentDidMount() {
      const newProps = incomingPropsModifierFunction ? incomingPropsModifierFunction(this.props) : this.props;
      this.syncProps(newProps);
    }
    componentDidUpdate(prevProps) {
      const newProps = incomingPropsModifierFunction ? incomingPropsModifierFunction(this.props) : this.props;
      this.syncProps(newProps, prevProps);
    }
    syncProps(props, oldProps = null) {
      const el = this.element.current;
      Object.keys(props).forEach(name => {
        let attributeValue = null;
        if (name === "children") {
          return;
        }
        if (name === "className") {
          if (oldProps && props.className === oldProps.className) {
            return;
          }
          const newClassNames = {};
          const oldClassNames = el.classList;

          // eslint-disable-next-line no-return-assign
          props.className.split(" ").forEach(c => newClassNames[c] = true);
          oldClassNames.forEach(c => {
            if (newClassNames[c]) {
              delete newClassNames[c];
            } else {
              el.classList.remove(c);
            }
          });
          Object.keys(newClassNames).forEach(key => {
            if (key) {
              el.classList.add(key);
            }
          });
          return;
        }
        if (Array.isArray(props[name]) || typeof props[name] === "object" && props[name] !== null) {
          attributeValue = JSON.stringify(props[name]);
        }
        if (name.indexOf("on") === 0 && name[2] === name[2].toUpperCase()) {
          this.syncEvent(name.substring(3), props[name]);
        } else if (props[name] === false) {
          el.removeAttribute(name);
        } else if (typeof props[name] === "function") {
          // if a function is being passed in, assume we are setting the element property of the same name to that function
          // e.g. setting the requestCurrentAccessToken property of aui-uploader to the given function
          el[name] = props[name];
        } else {
          el.setAttribute(name.toLowerCase(), attributeValue || props[name]);
        }
      });
      // Add an attribute to these components to indicate that they should not remove themselves from the DOM when dismissed
      const selfRemovingComponents = ["S-ALERT", "S-BANNER", "S-TAG"];
      if (selfRemovingComponents.includes(el.tagName)) {
        el.setAttribute("noremove", true);
      }
    }
    syncEvent(eventName, newEventHandler) {
      const el = this.element.current;
      const eventNameLc = `s-${eventName[0].toLowerCase()}${eventName.substring(1)}`;
      const eventStore = el.__events || (el.__events = {});
      const oldEventHandler = eventStore[eventNameLc];
      if (oldEventHandler) {
        el.removeEventListener(eventNameLc, oldEventHandler);
      }
      if (newEventHandler) {
        el.addEventListener(eventNameLc, eventStore[eventNameLc] = function handler(event) {
          newEventHandler.call(this, event);
        });
      }
    }
    render() {
      return /*#__PURE__*/_react.default.createElement(CustomElement, {
        ref: this.element
      }, this.props.children);
    }
  };
};
exports.default = _default;